<template>
  <div class="login-page">
    <!-- 背景装饰 -->
    <div class="background-decor"></div>
    <!-- 头像区域 -->
    <div class="avatar-container">
      <!-- <img
        src="../../assets/image/woyaoyou_head_defult@2x.png"
        alt="头像"
        class="avatar"
      /> -->
    </div>
    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 标签栏（账号密码登录 / 验证码登录） -->
      <div class="tab-bar">
        <span
          :class="{ active: currentTab === 'password' }"
          @click="currentTab = 'password'"
          >Sorry！登录已超时
        </span>
        <!-- <span 
            :class="{ active: currentTab === 'code' }" 
            @click="currentTab = 'code'"
          >验证码登录(注册)</span> -->
      </div>
      <!-- 表单区域 -->
      <!-- <form class="login-form">
        <input
          type="text"
          placeholder="手机号"
          v-model="phone"
          class="input-field"
        />
        <input
          type="password"
          placeholder="密码"
          v-model="password"
          class="input-field"
          v-if="currentTab === 'password'"
        />
        <input
          type="text"
          placeholder="验证码"
          v-model="code"
          class="input-field"
          v-else
        /> -->
        <button type="button" class="login-btn" @click="navigatorTo">
          返回登录
        </button>
      </form>
    </div>
    <!-- ICP备案信息 -->
    <!-- <div class="icp-info">ICP备案：粤ICP备2025XXXX号</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
    console.log("expire");
  },
  methods: {
    navigatorTo() {
      this.$router.push('/ptlogin')
      // const baseURL = process.env.VUE_APP_BASE_API;
      // const url = `${baseURL}/beautiful#/ptlogin`;
      // window.location.href = url
    }
  },
};
</script>

<style scoped>
/* 页面整体样式 */
.login-page {
  width: 100%;
  height: 100vh;
  background: linear-gradient(120deg, #4e7ef7, #69b1ff); /* 渐变背景 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

/* 背景装饰（底部波浪线） */
.background-decor {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: url("../../assets/image/woyaoyou_bg_phone@2x.png") no-repeat
    bottom center; /* 可替换为实际波浪图 */
  background-size: cover;
  opacity: 0.5;
  z-index: 0;
}

/* 头像容器 */
.avatar-container {
  margin-bottom: 40px;
  z-index: 1;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

/* 登录卡片 */
.login-card {
  width: 320px;
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 标签栏 */
.tab-bar {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.tab-bar span {
  padding: 8px 16px;
  margin: 0 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  position: relative;
}
.tab-bar span.active {
  color: #4e7ef7;
  font-weight: bold;
}
.tab-bar span.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #4e7ef7;
}

/* 表单区域 */
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.input-field {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}
.input-field:focus {
  border-color: #4e7ef7;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  padding: 12px;
  background-color: #4e7ef7;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.login-btn:hover {
  background-color: #3a6bcf;
}

/* ICP备案信息 */
.icp-info {
  margin-top: 40px;
  font-size: 12px;
  color: #fff;
  z-index: 1;
}
</style>
